module.exports = __webpack_public_path__ + "img/edit_module.png";